<template>
  <div class="main">
    <img class="banner" src="@/assets/images/service_twt.png" alt="">
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="18">
        <img src="@/assets/images/twt1.png" alt="" />
        <img src="@/assets/images/twt3.png" alt="" />
        <img src="@/assets/images/twt2.png" alt="" />
        <img src="@/assets/images/twt4.png" alt="" />
        <img src="@/assets/images/twt5.png" alt="" />
        <img src="@/assets/images/twt6.png" alt="" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Product_amh",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>

.el-row{
  justify-content: center;
  text-align: center;
  .el-col{
    img{
      width: 100%;
    }
  }
}
</style>
